import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { B } from "../data/pillars";
import { QUESTION_GUIDES } from "../data/questionGuides";

export default function QuestionGuide({ qid, pillarColor }) {
  const [open, setOpen] = useState(false);
  const guide = QUESTION_GUIDES[qid];
  if (!guide) return null;

  return (
    <div style={{ marginBottom: 20 }}>
      <button
        onClick={() => setOpen(v => !v)}
        style={{
          background: open ? pillarColor + "15" : "#122240",
          border: `1px solid ${open ? pillarColor + "60" : "#1E3A5F"}`,
          borderRadius: 8,
          padding: "9px 16px",
          color: open ? pillarColor : B.subText,
          fontSize: 12,
          fontWeight: 700,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: 8,
          transition: "all 0.2s",
          letterSpacing: 0.5,
        }}
      >
        <span style={{ fontSize: 14 }}>💡</span>
        {open ? "Hide Guidance" : "Why does this matter? + Scoring Guide"}
        <span style={{ marginLeft: "auto", fontSize: 10 }}>{open ? "▲" : "▼"}</span>
      </button>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -8, height: 0 }}
            animate={{ opacity: 1, y: 0, height: "auto" }}
            exit={{ opacity: 0, y: -8, height: 0 }}
            style={{ overflow: "hidden" }}
          >
            <div style={{
              background: "#0D1B2E",
              border: `1px solid ${pillarColor}30`,
              borderTop: "none",
              borderRadius: "0 0 10px 10px",
              padding: "18px 20px",
            }}>
              {/* WHY IT MATTERS */}
              <div style={{
                background: pillarColor + "10",
                borderLeft: `3px solid ${pillarColor}`,
                borderRadius: "0 8px 8px 0",
                padding: "10px 14px",
                marginBottom: 16,
              }}>
                <div style={{ fontSize: 10, color: pillarColor, fontWeight: 800, letterSpacing: 2, marginBottom: 5 }}>
                  WHY THIS MATTERS
                </div>
                <p style={{ color: B.lightGray, fontSize: 13, lineHeight: 1.7, margin: 0 }}>
                  {guide.why}
                </p>
              </div>

              {/* RUBRIC */}
              <div style={{ fontSize: 10, color: B.subText, fontWeight: 800, letterSpacing: 2, marginBottom: 10 }}>
                SCORING GUIDE — WHICH LEVEL DESCRIBES YOU?
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                {guide.rubric.map(r => {
                  const levelColors = [B.red, B.orange, B.yellow, B.green, B.teal];
                  const c = levelColors[r.level - 1];
                  return (
                    <div key={r.level} style={{
                      display: "flex",
                      gap: 10,
                      alignItems: "flex-start",
                      background: "#122240",
                      borderRadius: 8,
                      padding: "10px 12px",
                      border: `1px solid ${c}20`,
                    }}>
                      <div style={{
                        width: 24,
                        height: 24,
                        borderRadius: "50%",
                        background: c + "25",
                        border: `1.5px solid ${c}`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 11,
                        fontWeight: 800,
                        color: c,
                        flexShrink: 0,
                        marginTop: 1,
                      }}>
                        {r.level}
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ color: B.white, fontSize: 12, fontWeight: 600, marginBottom: 3 }}>
                          {r.label}
                        </div>
                        <div style={{
                          color: B.subText,
                          fontSize: 11,
                          lineHeight: 1.5,
                          fontStyle: "italic",
                          display: "flex",
                          alignItems: "flex-start",
                          gap: 5,
                        }}>
                          <span style={{ color: c, flexShrink: 0 }}>eg.</span>
                          {r.example}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}